import { METADATA_KIND } from "@/consts/metadata";

export default {
  filterByInteraction(state) {
    if (!Array.isArray(state.metadatas)) {
      return [];
    }
    return state.metadatas.filter((metadata) => metadata.has_permission && metadata.kind === METADATA_KIND.INTERACTION);
  },
  getTags(state) {
    const feed = [
      { id: 1, value: "customer.name}" },
      { id: 2, value: "customer.firstname}" },
      { id: 3, value: "organization.name}" },
      { id: 4, value: "survey.questions}" },
      { id: 5, value: "survey.estimatedtime}" }
    ];
    let count = 6;
    let metadatas = [];
    if (state.metadatas !== null) {
      metadatas = state.metadatas;
      if (metadatas) {
        metadatas.forEach((metadata) => {
          if (metadata.kind === METADATA_KIND.CUSTOMER) {
            feed.push({ id: count, value: "customer." + metadata.name + "}" });
          } else if (metadata.kind === METADATA_KIND.INTERACTION) {
            feed.push({ id: count, value: "interaction." + metadata.name + "}" });
          }
        });
      }
    }
    return feed;
  }
};
